import { Upload, FileText, AlertTriangle } from 'lucide-react';

/**
 * Single-file upload field with inline error display.
 * Reused by JobApplicationModal for resume + additional document slots.
 */
export default function FileUploadField({
  label,
  helperText,
  file,
  onChange,
  error,
  accept,
  testId,
  icon = 'upload',
}) {
  const Icon = icon === 'upload' ? Upload : FileText;
  const iconColor = icon === 'upload' ? 'text-[#F2B705]' : 'text-[#888]';
  const borderClass = error ? 'border-red-500/40' : 'border-white/10';

  return (
    <div>
      <label className="text-xs uppercase tracking-widest text-[#A3A3A3] font-bold mb-1.5 block">
        {label}{helperText && ' '}{helperText && <span className="normal-case tracking-normal text-[10px] text-[#666]">({helperText})</span>}
      </label>
      <label className={`flex items-center gap-3 px-4 py-3 border ${borderClass} bg-[#0a0a0a] hover:border-[#F2B705]/40 cursor-pointer transition-colors`}>
        <Icon size={16} className={`${iconColor} shrink-0`} />
        <span className="text-sm text-white truncate flex-1">{file ? file.name : 'Select file…'}</span>
        {file && <span className="text-[10px] text-[#666] shrink-0">{(file.size / 1024).toFixed(0)} KB</span>}
        <input
          type="file"
          accept={accept}
          onChange={onChange}
          className="hidden"
          data-testid={testId}
        />
      </label>
      {error && (
        <p className="text-xs text-red-400 mt-1 flex items-center gap-1">
          <AlertTriangle size={11} /> {error}
        </p>
      )}
    </div>
  );
}
